import BarChart from "@mui/icons-material/BarChart";
import Campaign from "@mui/icons-material/Campaign";
import Folder from "@mui/icons-material/Folder";
import Groups from "@mui/icons-material/Groups";
import Lock from "@mui/icons-material/Lock";
import LocalOffer from "@mui/icons-material/LocalOffer";
import Person from "@mui/icons-material/Person";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import QrCodeScanner from "@mui/icons-material/QrCodeScanner";
import Storefront from "@mui/icons-material/Storefront";

export const retailModulesList = [
  { title: "Assisted Checkout", icon: QrCodeScanner, path: "/retail", useRetailAlias: true },
  { title: "Sales Reports", icon: BarChart, path: "/salesstats", retailStatus: "revamp" },
  { title: "Products and Inventory", icon: Storefront, path: "/product-items-stock" },
  { title: "Access", icon: Lock, path: "/access-management", retailStatus: "revamp" },
  { title: "Promos", icon: LocalOffer, path: "/vouchers" },
  { title: "Reports", icon: Folder, path: "/reports", retailStatus: "limited" },
  { title: "Customer", icon: Groups, path: "/customers", retailStatus: "revamp" },
  { title: "Promotions", icon: Campaign, path: "/promotions", retailStatus: "revamp" },
  { title: "Configuration", icon: ReceiptLong, path: "/config", retailStatus: "limited" },
  { title: "Account Management", icon: Person, path: "/account-management", retailStatus: "limited" },
];

export const retailModuleDetails = {
  "Sales Reports": "Daily totals, transaction logs, and exports.",
  "Products and Inventory": "Catalog, item records, and stock tools.",
  "Assisted Checkout": "Barcode punching, cart overview, and assisted checkout prep.",
  Access: "Roles, staff accounts, and permissions.",
  Promos: "Product bundles, discounts, and promo history.",
  Reports: "Operational reports and records.",
  Customer: "Registered customers and profiles.",
  Promotions: "Branding, media, and promo assets.",
  Configuration: "Receipt and POS settings.",
  "Account Management": "Account settings and security.",
};
